import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';

export default class AdminCalendarEventsCalendarEventRoute extends Route {
  // Services
  @service breadcrumb;
  @service store;

  // Hooks
  async model({ calendar_event_id }) {
    const { content } = await this.store.request(
      findRecord('calendar-event', calendar_event_id),
    );

    return content.data;
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
